import styled, { css } from "styled-components";

export const Container = styled.div`
    font-size: ${props => props.size ? props.size : 0};
    display: flex;
    align-items: center;
    margin-right: 0.2rem;

    .purple{
        color: #7A05A7;
    }

    ${props => props.absolute && css`
        position: absolute;
        left: -3rem;
    `}
`